/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
 
 import { Link } from "react-router-dom";
import Globals from "../shared/Globals";
import L from "./Lang"
import BaseCom from "./BaseCom";
import { withParamsAndNavigate } from "./WithParamsAndNavigate";
import { qreq } from "../shared/qrequest";
import Icon from "./Icon";

class EncounterList extends BaseCom {
    constructor(props) {
        super(props);
        this.state = {
            list: []
        };
        this.load = this.load.bind(this);
    }

    componentDidMount() {
        this.load();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.orderID !== this.props.orderID) {
            this.load();
        }
    }

    load() {
        qreq.get('/api/visit/list/order/' + this.props.orderID, j => {
            if (j.list)
                this.setState({ list: j.list });
            else
                this.alert(j.errorMessage);
        }, this.unkownErrorCallback);
    }

    render() {
        return (
            <>
            <p><L>There are a total of</L><strong>{this.state.list?.length} {this.state.list?.length === 1 ? 'encounter' : 'encounters'}</strong><L>in which</L><strong>{this.state.list?.filter(a => a.isPlacement).length} {this.state.list?.filter(a => a.isPlacement).length === 1 ? 'is a' : 'are'} placements</strong><L>.</L></p>
            <p><i><L>Sorted by schedule date, most recent ones first.</L></i></p>
            <table className="table">
                <thead>
                    <tr>
                        <th><L>Scheduled</L></th>
                        <th><L>Assigned</L></th>
                    </tr>
                </thead>
                <tbody>
                    {this.state.list?.map((i, idx) => <tr key={idx}>
                        <td>
                            <Link to={`/visit/view/${i.id}`}>
                                {Globals.toLongLocalDateString(i.scheduleDate)}
                                {i.isPlacement && <> <Icon icon="faBandage" className="text-muted" /> </>}
                            </Link>
                            <small className="d-block text-muted">{Globals.toMDYLocalDateString(i.scheduleDate)}</small>
                        </td>
                        <td>
                            {i.assignedToUserName ?? <i><L>Unassigned</L></i>}
                        </td>
                    </tr>)}
                </tbody>
            </table>
            </>
        );

    }
}

export default withParamsAndNavigate(EncounterList);